package com.nnod.ui.theme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import nnod.ui.generated.resources.GenSekiGothicJP_B
import nnod.ui.generated.resources.GenSekiGothicJP_R
import nnod.ui.generated.resources.Res
import org.jetbrains.compose.resources.Font

@Composable
fun nnodFontFamily(): FontFamily = FontFamily(
    Font(resource = Res.font.GenSekiGothicJP_R, weight = FontWeight.Normal, style = FontStyle.Normal),
    Font(resource = Res.font.GenSekiGothicJP_R, weight = FontWeight.Medium, style = FontStyle.Normal),
    Font(resource = Res.font.GenSekiGothicJP_B, weight = FontWeight.SemiBold, style = FontStyle.Normal),
    Font(resource = Res.font.GenSekiGothicJP_B, weight = FontWeight.Bold, style = FontStyle.Normal),
    Font(resource = Res.font.GenSekiGothicJP_B, weight = FontWeight.ExtraBold, style = FontStyle.Normal),
)

@Composable
fun nnodTypography(): Typography {
    val font = nnodFontFamily()
    val base = Typography()
    fun androidx.compose.ui.text.TextStyle.withFont() = copy(fontFamily = font)
    return Typography(
        displayLarge   = base.displayLarge.withFont(),
        displayMedium  = base.displayMedium.withFont(),
        displaySmall   = base.displaySmall.withFont(),
        headlineLarge  = base.headlineLarge.withFont(),
        headlineMedium = base.headlineMedium.withFont(),
        headlineSmall  = base.headlineSmall.withFont(),
        titleLarge     = base.titleLarge.withFont(),
        titleMedium    = base.titleMedium.withFont(),
        titleSmall     = base.titleSmall.withFont(),
        bodyLarge      = base.bodyLarge.withFont(),
        bodyMedium     = base.bodyMedium.withFont(),
        bodySmall      = base.bodySmall.withFont(),
        labelLarge     = base.labelLarge.withFont(),
        labelMedium    = base.labelMedium.withFont(),
        labelSmall     = base.labelSmall.withFont(),
    )
}

internal val NnodTypography = Typography()
